import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { Board, UUID } from "@/lib/types";

interface Vars {
  boardId: UUID;
  workspaceId: UUID;
}

export function useDeleteBoard() {
  const qc = useQueryClient();
  return useMutation<void, Error, Vars>({
    mutationFn: ({ boardId }) => api.deleteBoard(boardId),
    onSuccess: (_void, { boardId, workspaceId }) => {
      qc.setQueryData<Board[]>(queryKeys.boards(workspaceId), (prev) =>
        prev ? prev.filter((b) => b.id !== boardId) : prev,
      );
      qc.setQueryData<Board[]>(queryKeys.myBoards, (prev) =>
        prev ? prev.filter((b) => b.id !== boardId) : prev,
      );
      // Pinned boards: drop the deleted entry from the cached list too so the
      // LeftRail Angeheftet section reflects the deletion instantly.
      qc.setQueryData<Board[]>(queryKeys.pinnedBoards, (prev) =>
        prev ? prev.filter((b) => b.id !== boardId) : prev,
      );
      void qc.invalidateQueries({ queryKey: queryKeys.boards(workspaceId) });
      void qc.invalidateQueries({ queryKey: queryKeys.myBoards });
      void qc.invalidateQueries({ queryKey: queryKeys.pinnedBoards });
    },
  });
}
